import { useMemo } from "react";
import { Star } from "lucide-react";

export default function StarGlow({ onClose }) {
  const stars = useMemo(
    () =>
      Array.from({ length: 26 }, () => ({
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: 10 + Math.random() * 24,
        delay: Math.random() * 2.4,
        dur: 1.6 + Math.random() * 1.8,
      })),
    []
  );
  return (
    <div
      className="absolute inset-0 z-20 flex items-center justify-center overflow-hidden cursor-pointer"
      style={{ background: "rgba(38, 52, 64, 0.85)", backdropFilter: "blur(3px)" }}
      onClick={onClose}
      data-testid="star-glow-overlay"
    >
      <style>{`
        @keyframes tillo-twinkle { 0%,100% { opacity:.15; transform:scale(.7); } 50% { opacity:1; transform:scale(1.15); } }
        @keyframes tillo-pop { 0% { opacity:0; transform:scale(.6); } 70% { transform:scale(1.05); } 100% { opacity:1; transform:scale(1); } }
      `}</style>
      {stars.map((s, i) => (
        <Star
          key={i}
          className="absolute"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: s.size,
            height: s.size,
            color: "#FFD76A",
            fill: "#FFD76A",
            animation: `tillo-twinkle ${s.dur}s ease-in-out ${s.delay}s infinite`,
            filter: "drop-shadow(0 0 8px #FFD76A)",
          }}
        />
      ))}
      <div
        className="relative text-center px-8 py-6 rounded-3xl mx-4"
        style={{
          background: "#FFF8EC",
          border: "3px solid #FFE3A3",
          animation: "tillo-pop .6s ease-out",
          maxWidth: "85%",
        }}
        data-testid="star-glow-message"
      >
        <img src="/tillo.png" alt="Tillo" className="w-20 mx-auto mb-2 drop-shadow" />
        <div className="font-display text-2xl" style={{ color: "#3E6E64" }}>
          Well done, little star!
        </div>
        <div className="text-sm mt-1.5 font-semibold" style={{ color: "#C98A2B" }}>
          Tillo is so proud of you ✦ tap anywhere to close
        </div>
      </div>
    </div>
  );
}
